export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12883.50f26f4e.jpg";